export const cncTranslations = {
  en: {
    hero: {
      badge: 'High Precision CNC Machining',
      title1: 'Precision',
      titleCNC: 'CNC Machining',
      title2: 'Specialists in',
      titleMaterials: 'G10, FR4, aluminium',
      titleAnd: 'and',
      titlePhenolic: 'phenolic materials',
      subtitle: 'Manufacturing prototypes, tooling, spare parts, and small-to-medium batch production with high quality and competitive lead times.',
      cta1: 'Request Quote',
      cta2: 'Send CAD File',
      trust1: 'Tight tolerances',
      trust2: 'ISO 9001',
      trust3: 'Integrated CAD-CAM'
    },
    capabilities: {
      title: 'Machining',
      titleAccent: 'Capabilities',
      items: [
        'Vertical machining centers and CNC lathe',
        'Advanced CAM programming',
        'Complete CAD–CAM–Manufacturing integration',
        'Dimensional control based on ISO 9001',
        'Complex parts manufacturing and tight tolerances',
        'Repeatable and documented processes'
      ]
    },
    materials: {
      title: 'Materials We',
      titleAccent: 'Master',
      technical: {
        title: 'Technical and high-abrasion materials',
        items: [
          'G10 / FR4',
          'Phenolics / Bakelite',
          'Engineering composites'
        ]
      },
      standard: {
        title: 'Standard industrial materials',
        items: [
          'Aluminum (6061, 7075)',
          'Carbon and alloyed steels',
          'Nylon, acetal, HDPE'
        ]
      },
      note: 'Note:',
      noteText: 'Specialized processes for abrasive, composite, and difficult-to-machine materials.'
    },
    applications: {
      title: 'CNC Machining',
      titleAccent: 'Applications',
      items: [
        'Functional prototypes',
        'Tooling and special fixtures',
        'Spare parts for production lines',
        'Assembly and test components',
        'Small and medium batches',
        'Overflow machining support'
      ]
    },
    advantages: {
      title: 'Competitive',
      titleAccent: 'Advantages',
      items: [
        'Specialists in difficult materials (G10, FR4, phenolics)',
        'In-house engineering for process optimization',
        'Short and flexible delivery times',
        'Clear and reliable technical communication',
        'Repeatable and consistent processes',
        'Design + manufacturing in one company'
      ]
    },
    midCta: {
      title: 'Need a',
      titleQuote: 'quote',
      titleOr: 'or',
      titleSupport: 'technical support?',
      subtitle: 'Send us your specifications and CAD files. We will respond with times and costs in less than 24 hours.',
      button1: 'Quote Now',
      button2: 'Send STEP File'
    },
    gallery: {
      title: 'Examples of',
      titleAccent: 'manufactured parts',
      images: [
        {
          title: 'High-Precision G10/FR4 Machining',
          caption: 'CNC machined part in G10/FR4 composite material - Tolerance ±0.05mm - ISO 9001 certified'
        },
        {
          title: 'Complex Phenolic Components',
          caption: 'Bakelite phenolic parts with tight tolerances - Specialized tooling for abrasive materials'
        },
        {
          title: 'Aluminum Precision Parts',
          caption: 'Aluminum 6061 components - 3-axis CNC machining - CAD-CAM integration'
        }
      ]
    },
    finalCta: {
      title: 'Ready to manufacture your next',
      titleAccent: 'project',
      subtitle: 'Contact us today and discover how we can support your precision CNC machining needs.',
      button1: 'Request Quote',
      button2: 'Contact DSI'
    },
    footer: {
      tagline: 'Precision CNC Machining',
      services: 'Services',
      links: [
        'Home',
        'CNC Machining',
        'Wire Harness Industry',
        'Automation'
      ],
      contact: 'Contact',
      location: 'Durango, Mexico',
      copyright: 'DSI Durango. All rights reserved.'
    }
  },
  es: {
    hero: {
      badge: 'Maquinado CNC de Alta Precisión',
      title1: '',
      titleCNC: 'Maquinado CNC',
      title2: 'de precisión. Especialistas en',
      titleMaterials: 'G10, FR4, aluminio',
      titleAnd: 'y',
      titlePhenolic: 'materiales fenólicos',
      subtitle: 'Fabricación de prototipos, herramentales, refacciones y producción de lotes pequeños y medianos con alta calidad y tiempos competitivos.',
      cta1: 'Solicitar cotización',
      cta2: 'Enviar archivo CAD',
      trust1: 'Tolerancias ajustadas',
      trust2: 'ISO 9001',
      trust3: 'CAD-CAM integrado'
    },
    capabilities: {
      title: 'Capacidades de',
      titleAccent: 'maquinado',
      items: [
        'Centros de maquinado vertical y torno CNC',
        'Programación CAM avanzada',
        'Integración completa CAD–CAM–Manufactura',
        'Control dimensional basado en ISO 9001',
        'Fabricación de piezas complejas y tolerancias ajustadas',
        'Procesos repetibles y documentados'
      ]
    },
    materials: {
      title: 'Materiales que',
      titleAccent: 'dominamos',
      technical: {
        title: 'Materiales técnicos y de alta abrasión',
        items: [
          'G10 / FR4',
          'Fenólicos / Baquelita',
          'Composites de ingeniería'
        ]
      },
      standard: {
        title: 'Materiales industriales estándar',
        items: [
          'Aluminio (6061, 7075)',
          'Aceros al carbón y aleados',
          'Nylon, acetal, HDPE'
        ]
      },
      note: 'Nota:',
      noteText: 'Procesos especializados para materiales abrasivos, compuestos y de difícil maquinado.'
    },
    applications: {
      title: 'Aplicaciones del',
      titleAccent: 'maquinado CNC',
      items: [
        'Prototipos funcionales',
        'Herramentales y dispositivos especiales',
        'Refacciones para líneas de producción',
        'Piezas para ensamble y prueba',
        'Lotes pequeños y medianos',
        'Soporte en cargas de trabajo excedentes (overflow machining)'
      ]
    },
    advantages: {
      title: 'Ventajas',
      titleAccent: 'competitivas',
      items: [
        'Especialistas en materiales difíciles (G10, FR4, fenólicos)',
        'Ingeniería interna para optimización de procesos',
        'Tiempos de entrega cortos y flexibles',
        'Comunicación técnica clara y confiable',
        'Procesos repetibles y consistentes',
        'Diseño + manufactura en una sola empresa'
      ]
    },
    midCta: {
      title: '¿Necesitas una',
      titleQuote: 'cotización',
      titleOr: 'o',
      titleSupport: 'apoyo técnico?',
      subtitle: 'Envíanos tus especificaciones y archivos CAD. Te responderemos con tiempos y costos en menos de 24 horas.',
      button1: 'Cotizar ahora',
      button2: 'Enviar archivo STEP'
    },
    gallery: {
      title: 'Ejemplos de',
      titleAccent: 'piezas fabricadas',
      images: [
        {
          title: 'Maquinado de Alta Precisión en G10/FR4',
          caption: 'Pieza maquinada CNC en material compuesto G10/FR4 - Tolerancia ±0.05mm - Certificado ISO 9001'
        },
        {
          title: 'Componentes Fenólicos Complejos',
          caption: 'Piezas en baquelita fenólica con tolerancias ajustadas - Herramental especializado para materiales abrasivos'
        },
        {
          title: 'Piezas de Precisión en Aluminio',
          caption: 'Componentes en aluminio 6061 - Maquinado CNC 3 ejes - Integración CAD-CAM'
        }
      ]
    },
    finalCta: {
      title: 'Listos para fabricar tu siguiente',
      titleAccent: 'proyecto',
      subtitle: 'Comunícate con nosotros hoy y descubre cómo podemos apoyar tus necesidades de maquinado CNC de precisión.',
      button1: 'Solicitar cotización',
      button2: 'Contactar a DSI'
    },
    footer: {
      tagline: 'Maquinado CNC de Precisión',
      services: 'Servicios',
      links: [
        'Inicio',
        'Maquinado CNC',
        'Industria Arnesera',
        'Automatización'
      ],
      contact: 'Contacto',
      location: 'Durango, México',
      copyright: 'DSI Durango. Todos los derechos reservados.'
    }
  }
};